import { render, staticRenderFns } from "./coassurance.vue?vue&type=template&id=4c88e952"
import script from "./coassurance.vue?vue&type=script&lang=js"
export * from "./coassurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports